import axios from "axios";
import { apiEndpoint } from '@iso/lib/helpers/endpoint';
import { authHeader } from '@iso/lib/helpers/authHeader';

export const timesheetService = {
  getList,
  approve,
  approveAll,
};

function getList(propertyId, periodStart) {
  return axios
    .get(apiEndpoint.timesheets, {
      headers: authHeader(),
      params: { property_id: propertyId, period_start: periodStart },
    })
    .then((res) => {
      if (res && res.status === 200 && res.data.code === '0000') {
        return res.data;
      }
      return { rows: [], summary: {} };
    });
}

function approve(data) {
  return axios
    .post(apiEndpoint.timesheetApprove, data, { headers: authHeader() })
    .then((res) => (res && res.status === 200 ? res.data : {}));
}

function approveAll(data) {
  return axios
    .post(apiEndpoint.timesheetApproveAll, data, { headers: authHeader() })
    .then((res) => (res && res.status === 200 ? res.data : {}));
}
